<template>
  <fullscreen-overlay-frame :title="deviceName"
                            icon="devices"
                            color="primary"
                            centered
                            closable
                            @close="close">

    <template v-slot:content>
      <v-card class="mb-4">
        <v-list class="px-0">
          <!-- device name -->
          <v-list-item>
            <v-list-item-content v-if="editName">
              <v-text-field outlined dense persistent-hint
                            autofocus
                            :hint="$t('linked-devices-card.device-name')"
                            v-model="deviceName"
                            @keyup.enter="saveName"
                            @keyup.esc="cancelEdit">
                <template v-slot:append>
                  <v-btn icon small
                         :loading="loading.saving"
                         @click="saveName">
                    <v-icon>check</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
            </v-list-item-content>
            <v-list-item-content v-else>
              <v-list-item-title v-text="deviceName"/>
              <v-list-item-subtitle class="font-size-02"
                                    v-text="$t('linked-devices-card.device-name')"/>
            </v-list-item-content>
            <v-list-item-action v-if="!editName">
              <v-btn icon @click="editName = true">
                <v-icon class="non-flip">edit</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>

          <!-- last used -->
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title v-text="formatExact(data && data.last_used)"/>
              <v-list-item-subtitle class="font-size-02"
                                    v-text="$t('linked-devices-card.last-used-label')"/>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </template>

    <template v-slot:actions>
      <v-btn large depressed outlined
             color="primary"
             class="action-button"
             :loading="loading.deleting"
             @click="deleteDevice">
        {{ $t('linked-devices-card.unlink') }}
      </v-btn>
    </template>
  </fullscreen-overlay-frame>
</template>

<script>
import FullscreenOverlayFrame from "@/templates/dialogs/FullscreenOverlayFrame.vue";
import moment from "moment";

export default {
  name: 'EditLinkedDeviceDialog',
  components: {FullscreenOverlayFrame},
  props: ['data'],

  data() {
    return {
      loading: {
        saving: false,
        deleting: false
      },
      deviceName: '',
      editName: false
    }
  },

  methods: {
    init() {
      this.deviceName = this.getDeviceName()
      this.editName = false
    },

    getDeviceName() {
      try {
        const meta = JSON.parse(this.data?.metadata)
        return meta?.name || this.$t('linked-devices-card.default-name')
      } catch {
        return this.$t('linked-devices-card.default-name')
      }
    },

    formatExact(dateString) {
      if (!dateString) return ''
      return moment(dateString).locale(this.$i18n.locale).format('L LT')
    },

    cancelEdit() {
      this.deviceName = this.getDeviceName()
      this.editName = false
    },

    saveName() {
      this.loading.saving = true
      this.$rhRequest.sendPost({
        endpoint: 'linked-login/rename',
        data: {
          name: this.deviceName,
          deviceId: this.data.device_id
        }
      }, () => {
        this.loading.saving = false
        this.editName = false
        this.$root.bisatoast.success({message: this.$t('linked-devices-card.rename-success'), showCloseBtn: true})
        this.$root.$emit('updateLinkedDevices')
      }, () => {
        this.loading.saving = false
        this.$root.bisatoast.error({message: this.$t('app.generic-error'), showCloseBtn: true})
      })
    },

    deleteDevice() {
      this.$root.bisadialog.toggle('confirmation', true, {
        maxWidth: 400,
        title: this.$t('confirmation-dialog.title'),
        text: this.$t('linked-devices-card.unlink-confirm', {name: this.deviceName}),
        confirmLabel: this.$t('linked-devices-card.unlink')
      })
      this.$root.$on('dialogConfirmed', () => {
        this.loading.deleting = true
        this.$rhRequest.sendPost({
          endpoint: 'linked-login/unlink',
          data: {deviceId: this.data.device_id}
        }, () => {
          this.loading.deleting = false
          this.$root.bisatoast.success({message: this.$t('linked-devices-card.unlink-success'), showCloseBtn: true})
          this.close()
        }, () => {
          this.loading.deleting = false
          this.$root.bisatoast.error({message: this.$t('app.generic-error'), showCloseBtn: true})
        })
        this.$root.$off('dialogConfirmed')
      })
    },

    close() {
      this.$root.bisadialog.toggle('editLinkedDevice')
    }
  }
}
</script>
